import React, { Component } from "react"
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import {  fetchSouscripteurAction } from '../../actions/Souscription/Souscripteur'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class Submitted extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Soumission`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, reauthenticateMembers, reauthenticateCourtiers, getReauthenticateCourtiers, userGetSouscripteur } = this.props

    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateCourtiers, userGetSouscripteur } = nextProps
    
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getSouscripteur } = this.props
    const { isCurrentLoginCourtier } = this.state
    
    return (
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-body-second-content">
                  <div className="aps-dashboard-body-container-title">
                    <p className="uk-text-center aps-dashboard-body-title">
                      Bravo {isCurrentLoginCourtier ? reauthenticateCourtiers.courtierData.companyName : reauthenticateMembers.userData.lastname} !
                    </p>
                  </div>
                  <div className="aps-dashboard-body-container-desc">
                    {isCurrentLoginCourtier
                      ?
                        <p className="uk-text-center aps-dashboard-body-desc">
                          Le dossier de votre client {getSouscripteur.souscripteurData.lastname} {getSouscripteur.souscripteurData.firstname} a été soumis avec succès et est en attente de validation.
                        </p>
                      :
                        <p className="uk-text-center aps-dashboard-body-desc">
                          Votre dossier a été soumis avec succès et est en attente
                          de validation. En attendant, vous pouvez parrainer des amis et gagner des primes.
                        </p>
                    }
                  </div>
                  <div className="uk-text-center">
                    {!isCurrentLoginCourtier && (
                      <Link className="uk-button aps-btn-green" to="/parrain">Parrainer des amis</Link>
                    )}
                  </div>
                  {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                    <div>
                      <Redirect to='/connexion' push/>
                    </div>
                  }
                  {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                    <div>
                      <Redirect to='/connexion-intermediaires' push/>
                    </div>
                  }
                </div>
              </Dashboard>
          }
      <Footer />
    </div>);
  }
}
const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, getSouscripteur }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    getSouscripteur,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Submitted)



// WEBPACK FOOTER //
// ./src/containers/Submitted/index.js